import { HttpClient } from 'api/http-client';
import { StatusUpdateId } from 'api/models';
import { StatusUpdate, StatusUpdateUpdatePayload } from './types';

class StatusUpdatesHttpClient extends HttpClient {
  public async getStatusUpdatesList(
    projectID: number,
  ): Promise<StatusUpdate[]> {
    return this.get<StatusUpdate[]>(`/projects/${projectID}/status-updates`);
  }

  public async createStatusUpdate(
    data: Partial<StatusUpdate>,
  ): Promise<StatusUpdate> {
    return this.post('/status-updates', data);
  }

  public async getStatusUpdateDetails(
    statusUpdateId: StatusUpdateId,
  ): Promise<StatusUpdate> {
    return this.get(`/status-updates/${statusUpdateId[1]}`);
  }

  public async setStatusUpdateAsUnread(
    statusUpdateId: StatusUpdateId,
  ): Promise<StatusUpdate> {
    return this.get(`/status-updates/${statusUpdateId[1]}?seenByUser=true`);
  }

  public async updateStatusUpdate(data: StatusUpdate): Promise<StatusUpdate> {
    return this.put(`/status-updates/${data.statusUpdateId}`, data);
  }

  public async update(
    statusUpdateId: number,
    data: StatusUpdateUpdatePayload,
  ): Promise<StatusUpdate> {
    return this.put(`/status-updates/${statusUpdateId}`, data);
  }

  public async publish(statusUpdateId: number): Promise<StatusUpdate> {
    return this.post(`/status-updates/${statusUpdateId}/publish`);
  }

  public downloadStatusUpdateAttachmentsUrl(statusUpdateId: number): string {
    return `${this.BASEURL}/status-updates/${statusUpdateId}/attachments/download`;
  }

  public async deleteStatusUpdate(data: StatusUpdate): Promise<StatusUpdate> {
    return this.delete(`/status-updates/${data.statusUpdateId}`);
  }
}

export const StatusUpdatesAPI = new StatusUpdatesHttpClient();
